import { Injectable, Inject } from '@angular/core';
import { of, throwError } from 'rxjs'
import { catchError, first, retryWhen, timeout } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { LbHttpService } from '../lb-http.service';
import { ErrorService } from '../utils/error.service';
import { LocalStorageService } from '../utils/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SsoService {

  constructor(
    private http: HttpClient,
    public configService: ConfigService,
    public lbHttpService: LbHttpService,
    public errorService: ErrorService,
    public localStorageService: LocalStorageService
  ) { }

  public httpGetSsoInformation(subDomain: string) {
    let url: string = this.configService.getSsoInformation
    url += '?subDomain=' + subDomain

    return this.http.get(url).pipe(
      timeout(this.configService.defaultHttpTimeout),
      first(),
      retryWhen(this.lbHttpService.genericRetryStrategy({})),
      catchError((error) => {
        this.errorService.logError('Error while getting ssoInformation', error)
        return throwError(error)
      })
    )
  }

  public getSsoAuthenticationUrl(): string {
    let ssoInformation = this.localStorageService.getCurrentSsoInformation()
    if (ssoInformation
      && ssoInformation.data
      && ssoInformation.data.ssoLogin
      && ssoInformation.data.ssoLogin.redirectUrl
      && ssoInformation.data.ssoLogin.ssoAccessTokenQueryName
      && ssoInformation.data.ssoLogin.ssoAuthUrl
      && ssoInformation.data.ssoLogin.ssoClientId
    ) {
      let nonce: string = encodeURIComponent(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15))
      let ssoAuthentication: string = ssoInformation.data.ssoLogin.ssoAuthUrl
      ssoAuthentication = ssoAuthentication.replace('{SSO_CLIENT_ID}', encodeURIComponent(ssoInformation.data.ssoLogin.ssoClientId))
      ssoAuthentication = ssoAuthentication.replace('{NONCE}', encodeURIComponent(nonce))
      ssoAuthentication = ssoAuthentication.replace('{SSO_ACCESS_TOKEN_QUERY_NAME}', encodeURIComponent(ssoInformation.data.ssoLogin.ssoAccessTokenQueryName))
      ssoAuthentication = ssoAuthentication.replace('{REDIRECT_URL}', encodeURIComponent(ssoInformation.data.ssoLogin.redirectUrl))

      if (ssoInformation.data.ssoLogin.ssoScope) {
        ssoAuthentication = ssoAuthentication.replace('{SSO_SCOPE}', encodeURIComponent(ssoInformation.data.ssoLogin.ssoScope))
      }
      const ssoRedirectUrl = window.location.origin + '/v1/redirect_sso'
      ssoAuthentication = ssoAuthentication.replace('{SSO_STATE}', encodeURIComponent(btoa(ssoRedirectUrl)))
      return ssoAuthentication
    }
    return ''
  }

}
